export type RealtimeEvent = {
  type?: string;
  resource?: { id?: string };
  payload?: { conversationId?: string };
};

export function realtimeInvalidationKeys(event: RealtimeEvent): readonly (readonly string[])[] {
  const conversationId = event.payload?.conversationId;
  const keys: string[][] = [
    ['conversations'],
    conversationId ? ['conversation-items', conversationId] : ['conversation-items'],
  ];
  if (conversationId) {
    keys.push(['conversation', conversationId]);
    if (event.type?.startsWith('game.')) keys.push(['conversation-game', conversationId]);
  }
  if (event.type?.startsWith('game.') && event.resource?.id) {
    keys.push(['game', event.resource.id]);
  }
  if (event.type === 'match.created' || event.type === 'conversation.closed') {
    keys.push(['likes']);
  }
  if (event.type === 'reaction.like_received') {
    keys.push(['likes-unread'], ['likes'], ['discovery']);
  }
  if (event.type === 'profile.avatar_changed') {
    keys.push(['profile'], ['conversation']);
  }
  return keys;
}
/** Bounded REST reconciliation after websocket reconnect or Telegram WebView resume. */
export function realtimeRecoveryKeys(): readonly (readonly string[])[] {
  return [
    ['conversations'],
    ['conversation-items'],
    ['conversation-game'],
    ['discovery'],
    ['likes-unread'],
    ['likes'],
  ];
}
